import { render, staticRenderFns } from "./RoadUserAccidentApprove.vue?vue&type=template&id=f6da76c6"
import script from "./RoadUserAccidentApprove.vue?vue&type=script&lang=js"
export * from "./RoadUserAccidentApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports